var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.87568 23H1.23784V8.25405h4.63784V23zM3.61622 6.23243C2.18919 6.23243 1 5.04324 1 3.61622 1 2.18919 2.18919 1 3.61622 1c1.42702 0 2.61621 1.18919 2.61621 2.61622 0 1.42702-1.18919 2.61621-2.61621 2.61621zM23 23h-4.6378v-7.1351c0-1.6649 0-3.9244-2.3784-3.9244s-2.7351 1.9027-2.7351 3.8054V23H8.61081V8.25405h4.51889v2.02165h.119c.5945-1.18921 2.1405-2.3784 4.281-2.3784 4.6379 0 5.4703 3.0919 5.4703 7.0162V23z","fill":"#fff"}));
}

Linkedin.defaultProps = {"fill":"none","viewBox":"0 0 24 24"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
